import { Injectable } from '@angular/core';
import {InsuranceCompanyCode} from '../../../../../shared/models/insurance-company-code.enum';
import {CalculationService} from '../../calculation.service';
import {CalculationStorageService} from '../../../../../shared/services/calculation-storage.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Injectable({
  providedIn: 'root'
})
export class DiscountCodesService {

  get discounts(): any {
    return this.calculationService.calculationData.discounts;
  }

  constructor(private calculationService: CalculationService,
              private calculationStorage: CalculationStorageService) { }

  changeDiscountCode(icCode: InsuranceCompanyCode, discountCode: string): void {
    if (!isNotNullOrUndefined(this.calculationService.calculationData.discounts)) {
      this.calculationService.calculationData.discounts = {};
    }
    this.calculationService.calculationData.discounts[icCode] = discountCode;
    this.calculationStorage.updateCalculation();
  }
}
